import React, { useState } from 'react';

// React DateTime
import moment from 'moment';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import DatePicker from '../../../components/DatePicker';
import TeasuryTable from '../../../components/Content/TeasuryTable';

// Utils
import { parseCurrency } from '../../../../utils/SamuiUtils';

const Main = ({ name, onChangeMode, dataMasterList, dataDetailList }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [whDocNo, setWhDocNo] = useState("");

  // จากคลัง
  const [fromWhId, setFromWhId] = useState("");
  const [fromWhName, setFromWhName] = useState("");

  // ไปคลัง
  const [toWhId, setToWhId] = useState("");
  const [toWhName, setToWhName] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleChangeDate = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue = value && value instanceof moment ? value.format('YYYY-MM-DD') : value;

    if (name === 'fromDate') {
      setFromDate(newValue);
    } else {
      setToDate(newValue);
    }
  };

  const onRowSelected = (fromData) => {
    const filteredDetail = dataDetailList.filter(data => parseCurrency(data.WHDoc_Id) === fromData.WHDoc_Id);

    if (filteredDetail && filteredDetail.length > 0) {
      setFilteredDetailList(filteredDetail);
    } else {
      setFilteredDetailList([]);
    }

    setWhDocNo(fromData.WHDoc_No);

    if (selectedItemType === 2) {
      setFromWhId(filteredDetail[0].F_WH_Id);
      setFromWhName(filteredDetail[0].F_WH_Name);
      setToWhId(filteredDetail[0].T_WH_Id);
      setToWhName(filteredDetail[0].T_WH_Name);
    }
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState('');
  const [selectedItemType, setSelectedItemType] = useState(1);
  const filterDataByDate = (data) => {
    const from = fromDate ? moment(fromDate, 'YYYY-MM-DD') : null;
    const to = toDate ? moment(toDate, 'YYYY-MM-DD') : null;

    const docDate = moment(data.WHDoc_Date, 'YYYY-MM-DD HH:mm:ss.SSS');
    const isWithinRange = (!from || docDate.isSameOrAfter(from, 'day')) &&
      (!to || docDate.isSameOrBefore(to, 'day'));

    return isWithinRange;
  };
  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const matchesItemSearchTerm =
      data.WHDoc_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
      data.WHDocType_Name.toLowerCase().includes(searchItemTerm.toLowerCase());

    // ตรวจสอบการกรองตามประเภทเอกสาร
    const matchesItemType = selectedItemType ? data.WHDoc_Type === selectedItemType : true;

    // ตรวจสอบการกรองตามวันที่
    const matchesDateRange = filterDataByDate(data);

    return matchesItemSearchTerm && matchesItemType && matchesDateRange;
  });

  return <>
    <Breadcrumbs page={name} items={[
      { name: 'คลังสินค้า', url: '/Warehouse' },
      { name: name, url: '/treasury-documents' },
    ]} />
    <div className="container-fluid card py-3" style={{ maxHeight: "85vh", overflowY: "auto" }}>
      <div className="row mb-2 align-items-center">
        <div className="col-3">
          <button
            className="btn text-white"
            onClick={onChangeMode("FA")}
            style={{
              backgroundColor: 'rgb(239, 108, 0)',
              whiteSpace: 'nowrap',
              padding: '10px',
              fontSize: '15px'
            }}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> สร้างใบปรับปรุงสินค้า
          </button>
          <button
            className="btn text-white mx-3"
            onClick={onChangeMode("FT")}
            style={{
              backgroundColor: 'rgb(239, 108, 0)',
              whiteSpace: 'nowrap',
              padding: '10px',
              fontSize: '15px'
            }}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> สร้างใบโอนย้าย
          </button>
        </div>
        <div className="col-1" style={{ marginLeft: '-5%', width: '13%' }}>
          <div className="input-group">
            <span className="input-group-text">Search</span>
            <input
              type="text"
              className="form-control"
              value={searchItemTerm}
              onChange={(e) => setSearchItemTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="col-2" >
          <div className="radio-inline">
            <input
              className="form-check-input"
              type="radio"
              name="paymentStatus"
              value="1"
              checked={selectedItemType === 1}
              onChange={(e) => setSelectedItemType(1)}
            />
            <label className="form-check-label">ใบปรับสินค้า</label>
            <input
              className="form-check-input"
              type="radio"
              name="paymentStatus"
              value="2"
              checked={selectedItemType === 2}
              onChange={(e) => setSelectedItemType(2)}
            />
            <label className="form-check-label">ใบโอนย้าย</label>
          </div>
        </div>
        <div className="col-3">
          <div className="input-group">
            <span className="input-group-text">จากวันที่</span>
            <DatePicker
              label=""
              name="fromDate"
              value={fromDate}
              onChange={(date) => handleChangeDate(date, "fromDate")}
              disabled={false}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input-group">
            <span className="input-group-text">ถึง</span>
            <DatePicker
              label=""
              name="toDate"
              value={toDate}
              onChange={(date) => handleChangeDate(date, "toDate")}
              disabled={false}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="row ">
        <div className="col-2 mb-1" style={{ borderRight: '2px solid #c7c8c9' }}>
          <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
            <table id="basic-datatables" className="table table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '50%' }}>เลขเอกสาร</th>
                  <th className="text-center" style={{ width: '50%' }}>ประเภท</th>
                </tr>
              </thead>
              <tbody>
                {filteredItemData.length > 0 ? (
                  filteredItemData.map((data, index) => (
                    <tr
                      key={data.WHDoc_Id || index + 1}
                      onClick={() => onRowSelected(data)}
                      style={{ cursor: 'pointer' }}>
                      <td className="text-center">{data.WHDoc_No}</td>
                      <td className="text-center">{data.WHDocType_Name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-10 mb-3">
          {filteredDetailList.length !== 0 && (
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="card-title mb-0">
                เอกสารเลขที่: {whDocNo}
                {whDocNo.substring(0, 3) === 'TNS' && selectedItemType === 2 && (
                  <span> จากคลัง: {fromWhId} {fromWhName} ไปยังคลัง: {toWhId} {toWhName}</span>
                )}
              </p>
              <button
                disabled={true}
                className="btn d-flex align-items-center text-white" style={{
                  backgroundColor: 'rgb(239, 108, 0)',
                  fontSize: '16px'
                }}
              >
                <i className="fa fa-print me-2" aria-hidden="true"></i>
                พิมพ์ใบปรับยอด
              </button>
            </div>
          )}
          <TeasuryTable dataList={filteredDetailList} />
        </div>
      </div>
    </div>
  </>;
};

export default Main;
